<template>
  <div class="field is-grouped is-grouped-multiline">
    <b-autocomplete
      v-model="name"
      placeholder="Entrez votre nom"
      :keep-first="keepFirst"
      :data="filteredParticipants"
      field="name"
      @select="option => selectedUser = option"
      class="is-expanded"
    >

      <template slot-scope="props">
        {{ props.option.name }} <span class="is-pulled-right"><strong>{{ props.option.items.length }}</strong> item(s)</span>
      </template>
    </b-autocomplete>

    <p class="control">
      <button class="button is-info" @click="bringItems" :class="{ 'is-loading': isLoading }">Je ramène les items choisis</button>
    </p>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import { getEventById } from '@/shared/queries'

  const uuidv4 = require('uuid/v4')

  const createUser = gql`
    mutation createUser($name: String!, $secret: String!, $attendedEventsIds: [ID!], $items: [UseritemsItem!]) {
      createUser(name: $name, secret: $secret, attendedEventsIds: $attendedEventsIds, items: $items) {
        id
        name
        items {
          id
          name
          quantity
          unit
          type
        }
      }
    }
  `

  export default {
    name: 'user-box-form',
    props: {
      items: {
        type: Array,
        required: true,
        default: []
      },
      event: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        isLoading: false,
        keepFirst: true,
        name: '',
        selectedUser: null
      }
    },
    computed: {
      filteredParticipants () {
        return this.event.participants.filter((option) => {
          return option.name
            .toString()
            .toLowerCase()
            .indexOf(this.name.toLowerCase()) >= 0
        })
      }
    },
    methods: {
      bringItems () {
        this.isLoading = true

        let userItems = []
        let itemsToDeleteIds = []
        let deleteQueries = ''

        if (this.selectedUser) {
          for (let item of this.selectedUser.items) {
            userItems.push({
              eventId: this.event.id,
              name: item.name,
              quantity: item.quantity,
              type: item.type,
              unit: item.unit
            })
          }

          // Delete
          for (let item of this.selectedUser.items) {
            itemsToDeleteIds.push(item.id)
          }

          if (itemsToDeleteIds.length > 0) {
            for (let id of itemsToDeleteIds) {
              deleteQueries += id + ': deleteItem(id: "' + id + '") {id}'
            }
          }
        }

        let itemsToAdd = userItems.slice()

        for (let item of this.items) {
          itemsToAdd.push({
            eventId: this.event.id,
            name: item.name,
            quantity: item.quantity,
            type: item.type,
            unit: item.unit
          })
        }

        if (this.selectedUser) {
          this.updateUser(deleteQueries, this.selectedUser.id, this.event.id, itemsToAdd)
        } else {
          this.createUser(this.name, this.event.id, itemsToAdd)
        }
      },
      createUser (userName, eventId, items) {
        // Mutation
        this.$apollo.mutate({
          mutation: createUser,
          variables: {
            name: userName,
            secret: uuidv4(),
            attendedEventsIds: [eventId],
            items
          },
          refetchQueries: [{
            query: getEventById,
            variables: {
              id: eventId
            }
          }]
        }).then(() => {
          this.name = ''

          this.$toast.open({message: this.$t('saveListSuccess'), position: 'is-bottom', type: 'is-success'})
        }).catch((error) => {
          this.$ga && this.$ga.exception(error.message || error)

          this.$toast.open({message: this.$t('saveListError'), position: 'is-bottom', type: 'is-danger'})
        }).then(() => {
          this.isLoading = false
        })
      },
      updateUser (deleteQueries, userId, eventId, items) {
        let updateUser = gql`
          mutation updateUser($userId: ID!, $items: [UseritemsItem!]) {
            updateUser(id: $userId, items: $items) {
              id
              items {
                id
                name
                quantity
                unit
                type
              }
            }
            ${deleteQueries}
          }
        `

        // Mutation
        this.$apollo.mutate({
          mutation: updateUser,
          variables: {
            userId,
            items
          },
          update: (store, {data}) => {
            const result = store.readQuery({query: getEventById, variables: {id: eventId, userFilter: null}})

            for (let participant of result.Event.participants) {
              if (participant.id === userId) {
                participant.items = data.updateUser.items
              }
            }

            store.writeQuery({query: getEventById, variables: {id: eventId, userFilter: null}, data: result})
          }
        }).then(() => {
          // Result
          this.$toast.open({message: this.$t('saveListSuccess'), position: 'is-bottom', type: 'is-success'})
        }).catch((error) => {
          // Error
          this.$ga && this.$ga.exception(error.message || error)

          this.$toast.open({message: this.$t('saveListError'), position: 'is-bottom', type: 'is-danger'})
        }).then(() => {
          this.isLoading = false
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserBoxForm.vue